__webpack_require__.p = "https://scantek-dev.demomywebapp.com/";